import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { faSquarePlus } from '@fortawesome/pro-solid-svg-icons';
import { selectChannelListColumnVisibility } from '../../redux/slices/channelListSlice/channelListSlice';
import { selectAlertList } from '../../redux/slices/alertListSlice/alertListSlice';
import { selectRoomAlertDeviceList } from '../../redux/slices/deviceList/deviceListSlice';

/* istanbul ignore next */
function ChannelListTableRow({
  channel,
  onAddClick,
  onAlertsClick,
}) {
  const columnVisibility = useSelector(selectChannelListColumnVisibility);
  const alertList = useSelector(selectAlertList);
  const deviceList = useSelector(selectRoomAlertDeviceList);
  const hasMaxDevice = deviceList.find((d) => d.type === 'RAMAX');
  const filteredAlertList = Array.isArray(alertList)
    ? alertList
      .filter((alert) => alert && alert.channelKey.channelKey === channel.channelKey)
      .map((alert) => alert.id)
    : [];
  const getColStyle = (label) => (columnVisibility[label] === false ? { display: 'none' } : {});

  return (
    <tr>
      <td style={{ paddingLeft: '0.75rem', paddingRight: '1.0rem' }}>
        <FontAwesomeIcon icon={faSquarePlus} onClick={onAddClick} style={{ cursor: 'pointer' }} />
      </td>
      {columnVisibility.DeviceName && (
      <td
        className="ellipsis"
        style={getColStyle('DeviceName')}
        title={channel.deviceName}
      >
        <span>
          {channel.deviceName}
        </span>
      </td>
      )}
      {columnVisibility.SensorName && (
        <td
          className="ellipsis"
          style={getColStyle('SensorName')}
          title={channel.sensorName}
        >
          <span>
            {channel.sensorName}
          </span>
        </td>
      )}

      {(columnVisibility.ComponentName && hasMaxDevice) && (
      <td
        className="ellipsis"
        style={getColStyle('ComponentName')}
        title={channel.componentName}
      >
        <span>
          {channel.componentName}
        </span>

      </td>
      )}

      {columnVisibility.SensorType && (
        <td
          className="ellipsis"
          style={getColStyle('SensorType')}
          title={channel.sensorType}
        >
          <span>
            {channel.sensorType}
          </span>
        </td>
      )}

      {columnVisibility.SensorChannel && (
        <td
          className="ellipsis"
          style={getColStyle('SensorChannel')}
          title={channel.sensorChannel}
        >
          <span>
            {channel.sensorChannel}
          </span>
        </td>
      )}

      {columnVisibility.Port && (
        <td
          className="ellipsis"
          style={getColStyle('Port')}
          title={channel.port}
        >
          <span>
            {channel.port}
          </span>
        </td>
      )}

      {columnVisibility.LastReading && (
        <td
          className="ellipsis"
          style={getColStyle('LastReading')}
          title={channel.lastReading}
        >
          <span>
            {channel.lastReading}
          </span>
        </td>
      )}

      {columnVisibility.LastReceived && (
        <td
          className="ellipsis"
          style={getColStyle('LastReceived')}
          title={channel.lastReceived}
        >
          <span>
            {channel.lastReceived}
          </span>
        </td>
      )}

      {columnVisibility.DeviceType && (
        <td
          className="ellipsis"
          style={getColStyle('DeviceType')}
          title={channel.deviceType}
        >
          <span>
            {channel.deviceType}
          </span>
        </td>
      )}

      {columnVisibility.MACAddress && (
        <td
          className="ellipsis"
          style={getColStyle('MACAddress')}
          title={channel.macAddress}
        >
          <span>
            {channel.macAddress}
          </span>
        </td>
      )}

      {columnVisibility.SerialNumber && (
        <td
          className="ellipsis"
          style={getColStyle('SerialNumber')}
          title={channel.serialNumber}
        >
          <span>
            {channel.serialNumber}
          </span>
        </td>
      )}

      {columnVisibility.Alerts && (
        <td
          className="ellipsis"
          style={{ ...getColStyle('Alerts'), cursor: 'pointer', color: '#007bff' }}
          onClick={() => onAlertsClick(filteredAlertList)}
        >
          <span style={{ textDecoration: 'underline' }}>
            {channel.alertCount || 0}
          </span>
        </td>
      )}
    </tr>
  );
}

ChannelListTableRow.propTypes = {
  channel: PropTypes.shape({
    channelKey: PropTypes.string,
    sensorName: PropTypes.string,
    sensorType: PropTypes.string,
    sensorChannel: PropTypes.string,
    port: PropTypes.string,
    deviceName: PropTypes.string,
    lastReading: PropTypes.string,
    lastReceived: PropTypes.string,
    deviceType: PropTypes.string,
    macAddress: PropTypes.string,
    serialNumber: PropTypes.string,
    alertCount: PropTypes.number,
    componentName: PropTypes.string,
  }).isRequired,
  onAddClick: PropTypes.func.isRequired,
  onAlertsClick: PropTypes.func.isRequired,
};

export default ChannelListTableRow;
